__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/13dffb8/_next/";